export {registerTouchInteractions} from './registerTouchInteractions';
